import { render, staticRenderFns } from "./AddAllergy.vue?vue&type=template&id=f0b8a518"
import script from "./AddAllergy.vue?vue&type=script&lang=js"
export * from "./AddAllergy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports